import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  updateSportProviderSettings,
  UpdateSportProviderParams,
  SportProviderOverride,
} from "@/api/settings/sportProviders";
import { SettingsQueryKeys } from "@/tanstackQuery/queries/settings";

export interface UpdateSportProviderSettingsOptions {
  onSuccess?: (data: SportProviderOverride[]) => void;
  onError?: (error: Error) => void;
}

// The radio has no local mirror for non-football sports, so the override
// list is refreshed on success AND on error: after a failure the selection
// snaps back to server truth.
export const useUpdateSportProviderSettings = (
  options?: UpdateSportProviderSettingsOptions
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateSportProviderParams) =>
      updateSportProviderSettings(params),
    onSuccess: options?.onSuccess,
    onError: options?.onError,
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [SettingsQueryKeys.SportProviders],
      });
    },
  });
};
